import React from "react";
import { Link } from "react-router-dom";
import style from "../../assets/css/components/Header/LogoHeader.module.css";

function LogoHeader() {
  return (
    <div className={style.logo}>
      <Link to="/" className={style.link}>
        <h1 className={style.name}>
          Deportiv<span>istmo</span>
        </h1>
      </Link>
    </div>
  );
}

export default LogoHeader;
